import { createAction, props } from '@ngrx/store';

import {
  AbstractAggregation,
  AggregatedJobData,
  AggregationParams,
  Candidate,
} from '@shared/models';
import { ApiRequest } from '@shared/services/api.service';
import { ReferralReportsFilters } from '@modules/reports/models/referral-reports-filters';

export const AggregationLoadHiringManager = createAction(
  '[Aggregation] Load Hiring Manager',
  props<{ payload: ApiRequest<AggregationParams> }>(),
);

export const AggregationLoadHiringManagerSuccess = createAction(
  '[Aggregation] Load Hiring Manager Success',
  props<{ payload: AbstractAggregation<Candidate> }>(),
);

export const AggregationLoadHiringManagerFail = createAction(
  '[Aggregation] Load Hiring Manager Fail',
  props<{ error: any; jobId: number }>(),
);

export const LoadAggregatedJobsData = createAction(
  '[Aggregation] Load Aggregated Jobs Data',
  props<{
    jobsIds: number[];
    loadAggregationForSingleJob?: boolean;
    updateSingleAggregatedJobData?: boolean;
    filters?: any;
  }>(),
);

export const LoadAggregatedJobsDataForJob = createAction(
  '[Aggregation] Load Aggregated Jobs Data For Job',
  props<{ aggregatedJobsData: any; loadAggregationForSingleJob?: boolean; filters?: any }>(),
);

export const LoadAggregatedJobsDataSuccess = createAction(
  '[Aggregation] Load Aggregated Jobs Data Success',
  props<{ aggregatedJobsData: any }>(),
);

export const loadTotalDirectPerPhase = createAction(
  '[Aggregation] Load Total Direct Per Phase',
  props<{ filters: ReferralReportsFilters }>(),
);

export const loadTotalDirectPerPhaseSuccess = createAction(
  '[Aggregation] Load Total Direct Per Phase Success',
  props<{ totalDirectPerPhase: any[] }>(),
);

export const loadTotalDirectPerPhaseFail = createAction(
  '[Aggregation] Load Total Direct Per Phase Fail',
  props<{ error: any }>(),
);

export const loadActiveJobsCount = createAction(
  '[Aggregation] Load Active Jobs Count',
  props<{ filters: ReferralReportsFilters }>(),
);

export const loadActiveJobsCountSuccess = createAction(
  '[Aggregation] Load Active Jobs Count Success',
  props<{ activeJobsCount: number }>(),
);

export const loadActiveJobsCountFail = createAction(
  '[Aggregation] Load Active Jobs Count Fail',
  props<{ error: any }>(),
);

export const loadAggregatedMatches = createAction(
  '[Aggregation] Load Aggregated Matches',
  props<{ filters: ReferralReportsFilters }>(),
);

export const loadAggregatedMatchesSuccess = createAction(
  '[Aggregation] Load Aggregated Matches Success',
  props<{ aggregatedMatches: AggregatedJobData }>(),
);

export const loadAggregatedMatchesFail = createAction(
  '[Aggregation] Load Aggregated Matches Fail',
  props<{ error: any }>(),
);
